import React from 'react';
import { BRAND, BRAND_LIGHT, getThemeColors } from '../../../lib/theme';

/* ─── ShowAllLink ──────────────────────────────────────────────────────────── */

export function ShowAllLink({ label, onClick }: { label: string; onClick: (e: React.MouseEvent) => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: 'none', border: 'none', padding: 0,
        color: BRAND, fontSize: 11, fontWeight: 600, cursor: 'pointer',
        textDecoration: 'underline', textUnderlineOffset: 2,
      }}
    >{label} →</button>
  );
}

/* ─── WidgetCard ─────────────────────────────────────────────────────────────── */

export function WidgetCard({
  dark, title, badge, onShowAll, showAllLabel, loading, children,
}: {
  dark: boolean;
  title: string;
  badge?: string | number | null;
  onShowAll: (e: React.MouseEvent) => void;
  showAllLabel: string;
  loading?: boolean;
  children: React.ReactNode;
}) {
  const tc = getThemeColors(dark);
  return (
    <div style={{
      background: tc.card,
      border: `1px solid ${tc.border}`,
      borderRadius: 12,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 14px', borderBottom: `1px solid ${tc.border}`,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: tc.muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            {title}
          </span>
          {badge != null && (
            <span style={{
              fontSize: 11, fontWeight: 700, color: BRAND,
              background: BRAND_LIGHT, borderRadius: 999, padding: '1px 7px',
            }}>{badge}</span>
          )}
          {loading && <span style={{ fontSize: 11, color: tc.muted }}>…</span>}
        </div>
        <ShowAllLink label={showAllLabel} onClick={onShowAll} />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </div>
  );
}
